<template>
  <div style="display: flex;" :class="[$route.name === 'login' ? 'login-page' : '']">
    <div v-if="$route.name !== 'login'&&$route.name !== 'pldfExcl'" class="sidebar" style="min-width: 240px;z-index: 88;height: 100vh;">
      <left style="position: fixed;left: 0;top: 0;min-width: 240px;z-index: 555;" v-on:menuSelect="menuSelect">
      </left>
    </div>
    <div v-if="$route.name !== 'login' && $route.name !== 'pldfExcl'" class="sidebar"
      style="position: fixed;left: 0;top: 0;height: 64px;padding-left:240px;width:100vw;box-sizing: border-box; line-height: 64px; color: #515a6e; background-color: #fff;-webkit-transform-style: preserve-3d;transform-style: preserve-3d; border-bottom: 2px solid #ccc;z-index: 0;display: flex;align-items: center;justify-content: space-between;z-index: 87;">
      <div style="padding-left: 15px;font-size: 14px;font-weight: 600;color: #515a6e;">首页</div>
      <div style="display: flex;align-items: center;justify-content: center;margin-right: 15px;">
        <!-- <img src="" style="width: 32px;height: 32px;border-radius: 50%;background-color: #f0f0f0;cursor: pointer;" alt="">
        <div style="padding: 0 5px;font-size: 14px;">{{ phone }}</div> -->
        <img @click="logout" src="../src/assets/exit.png"
          style="width: 20px;height: 20px;border-radius: 50%;background-color: #eeeeee;cursor: pointer;" alt="">
      </div>
    </div>
    <div class="main-content" style="flex-grow: 1;">
      <!-- 路由视图 -->
      <a-config-provider :locale="locale">
        <router-view style="box-sizing: border-box;"></router-view>
      </a-config-provider>
    </div>
  </div>
</template>

<script>
import left from './components/left.vue'
import index from './content/index.vue'
import Fitness from './content/Fitness.vue'
import account from './content/account.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN';//引入antd中文包
import moment from 'moment';//引入moment 
moment.locale('zh_CN');//配置moment中文環境

export default {
  name: 'App',
  components: {
    left, index, Fitness, account
  },
  data() {
    return {
      componentId: 'index',
      locale: zhCN,
      phone: ''
    }
  },
  methods: {
    menuSelect(e) {
      console.log(e.key)
      // let key = e.key
      // this.componentId = e.key

    },
    logout() {
      this.$store.set('_token', null)
      this.$router.push('/login')
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

.main-content {
  flex-grow: 1;
  padding-top: 60px;
  /* 距离顶部导航栏的距离 */
  /* 其他样式 */
}

.login-page .main-content {
  padding-top: 0;
}
</style>
